<template>
    <div
        v-loading="imageLoading"
        element-loading-text="请稍等，图片上传中">
        <quill-editor
            ref="myQuillEditor"
            :content="value"
            :options="editorOption"
            @ready="initButton"
            @change="handleChange">
        </quill-editor>
        <el-upload
            style="display:none;"
            multiple
            class="editorUploadImg"
            action="https://ecogreenweb.icangjiang.com/upload/upyun"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-progress="onProgress">
        </el-upload>
    </div>
</template>

<script>
    //富文本编辑器
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import { quillEditor } from 'vue-quill-editor'

    export default {
        name: "quill",
        components:{
            quillEditor
        },
        props:{
            value: {  // 绑定的值
                default:'',
                required: true
            },
            placeholder:{
                default:'',
            },
        },
        data(){
            return{
                imageLoading:false,
                editorOption:{
                    placeholder: '',
                    // 主题
                    theme: 'snow',
                    modules: {
                        toolbar: {
                            // 工具栏选项
                            container:  [
                                // 加粗 斜体 下划线 删除线
                                ['bold', 'italic', 'underline', 'strike'],
                                // 加粗 斜体 下划线 删除线
                                ['blockquote', 'code-block'],
                                // 1、2 级标题
                                [{header: 1}, {header: 2}],
                                // 有序、无序列表
                                [{list: 'ordered'}, {list: 'bullet'}],
                                // 上标/下标
                                [{script: 'sub'}, {script: 'super'}],
                                // 缩进
                                [{indent: '-1'}, {indent: '+1'}],
                                // 文本方向
                                [{direction: 'rtl'}],
                                // 字体大小
                                [{size: ['small', false, 'large', 'huge']}],
                                // 标题
                                [{header: [1, 2, 3, 4, 5, 6, false]}],
                                // 字体颜色、字体背景颜色
                                [{color: []}, {background: []}],
                                // 字体种类
                                [{font: []}],
                                // 对齐方式
                                [{align: []}],
                                [{clean: '源码编辑'}], // 这是自己加的
                                // 链接、图片、视频
                                ['link', 'image'],
                                // 新添加的工具
                                ['sourceEditor']
                            ],
                            // 事件重写
                            handlers: {
                                shadeBox: null,
                                // 添加工具方法
                                sourceEditor: function () {
                                    const container = this.container;
                                    const firstChild = container.nextElementSibling.firstChild;

                                    // 在第一次点击源码编辑的时候，会在整个工具条上加一个div，层级比工具条高，再次点击工具条任意位置，就会退出源码编辑。可以在下面cssText里面加个背景颜色看看效果。
                                    if (!this.shadeBox) {
                                        let shadeBox = this.shadeBox = document.createElement('div');

                                        shadeBox.style.cssText = 'position:absolute; top:0; left:0; width:100%; height:100%; cursor:pointer';
                                        container.style.position = 'relative';
                                        container.appendChild(shadeBox);
                                        firstChild.innerText = firstChild.innerHTML;

                                        shadeBox.addEventListener('click', function () {
                                            this.style.display = 'none';
                                            firstChild.innerHTML = firstChild.innerText.trim();
                                        }, false);
                                    } else {
                                        this.shadeBox.style.display = 'block';
                                        firstChild.innerText = firstChild.innerHTML;
                                    }
                                },
                            },
                        }
                    },
                }
            }
        },
        mounted(){
            var vm = this;
            // 当点击图书上传是，触发elementui的upload点击
            var imgHandler = async function (image) {
                vm.addImgRange = vm.$refs.myQuillEditor.quill.getSelection();
                if (image) {
                   document.querySelector('.editorUploadImg .el-upload__input').click();
                }
            };

            vm.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', imgHandler);
        },
        methods:{
            // 在使用的页面中初始化按钮样式
            initButton: function () {
                // 样式随便改
                const sourceEditorButton = document.querySelector('.ql-sourceEditor');
                sourceEditorButton.style.cssText = 'font-size:18px';

                // 加了elementui的icon
                sourceEditorButton.classList.add('el-icon-edit-outline');
                // 鼠标放上去显示的提示文字
                sourceEditorButton.title = '源码编辑';
            },
            beforeAvatarUpload(file){
                const isLt2M = file.size / 1024 / 1024 < 15;
                if (!isLt2M) {
                    this.$message({
                        showClose:true,
                        message:'上传头像图片大小不能超过 15MB!',
                        type:'error'
                    });
                    return false;
                }
                return isLt2M;
            },
            onProgress() {
                this.imageLoading = true;
            },
            handleAvatarSuccess(res) {
                let quill = this.$refs.myQuillEditor.quill;
                try{
                    if (res.code == 0) {
                        // 获取光标所在位置
                        let length = quill.getSelection().index;
                        // 插入图片，res为服务器返回的图片链接地址
                        quill.insertEmbed(length, 'image', res.data.url)
                        // 调整光标到最后
                        quill.setSelection(length + 1);
 
                    } else {
                        this.$message({
                            showClose:true,
                            message:res.message,
                            type:'error'
                        });
                    }
                    this.imageLoading = false;
                }catch (e) {
                    this.$message({
                        showClose:true,
                        message:e.message,
                        type:'error'
                    });
                }
            },
            handleChange({ html }){
                this.$emit("input",html);
            }
        }
    }
</script>

<style scoped>
    >>>.ql-container{height: 400px;background: #fff;}
    .quill-form-item >>>.ql-editor{height:400px;}
</style>